import React from 'react';
import PropTypes from 'prop-types';
import { CAPACITY_CHECK } from '@shopDetails/constants';
import ErrorModalPreorderTimeFull from '@checkout/containers/ErrorModalPreorderTimeFull';
import { BoxMessage, MESSAGE_TYPE } from '@components/Messages';
import TimeLapse from '@components/Icons/TimeLapse';

function CapacityCheck({
  capacityCheck,
  shopIsOpen,
  acceptsPreOrder,
  businessType,
}) {
  if (!capacityCheck?.capacity) return null;
  return (
    <>
      {(capacityCheck.capacity === CAPACITY_CHECK.MEDIUM ||
        capacityCheck.capacity === CAPACITY_CHECK.LOW) &&
        shopIsOpen && (
          <BoxMessage
            type={MESSAGE_TYPE.INFO}
            title={capacityCheck.message.title}
            message={capacityCheck.message.description}
            icon={<TimeLapse size="medium" />}
          />
        )}
      {shopIsOpen && capacityCheck.capacity === CAPACITY_CHECK.NONE && (
        <ErrorModalPreorderTimeFull
          open
          title={capacityCheck.message.title}
          description={capacityCheck.message.description}
          businessType={businessType}
        />
      )}
      {!shopIsOpen &&
        capacityCheck.capacity === CAPACITY_CHECK.NONE &&
        acceptsPreOrder && <ErrorModalPreorderTimeFull open />}
    </>
  );
}

CapacityCheck.propTypes = {
  capacityCheck: PropTypes.object,
  shopIsOpen: PropTypes.bool.isRequired,
  acceptsPreOrder: PropTypes.bool.isRequired,
  businessType: PropTypes.string.isRequired,
};

export default React.memo(CapacityCheck);
